import { shrpaApi } from "./axios";
import moment from "moment";

// Types
import { CustomerGalleryPhotoGroupsFromServer } from "@contracts/photosPageData";

export default {
  /**
   * The Uploading Date is required to determine whether to create a new group when the customer uploads new assets outside a group
   */
  async upsertMyUploadsGroupPhotos(customerId: string, photoGalleryId: string | null, photoIds: Array<string>): Promise<CustomerGalleryPhotoGroupsFromServer> {
    const uri = `/photo-gallery/v2/${customerId}/my-uploads/photos`;

    const payload = JSON.stringify({
      photoIds,
      clientSideDateTime: moment().format(),
      photoGalleryId: photoGalleryId ?? "",
    });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await shrpaApi.put<CustomerGalleryPhotoGroupsFromServer>(uri, payload, config);

    return data;
  },

  async updateMyUploadsGroupCommentAndTitle(customerId: string, photoGalleryId: string, title: string, comment: string): Promise<CustomerGalleryPhotoGroupsFromServer> {
    const uri = `/photo-gallery/v2/${customerId}/my-uploads/${photoGalleryId}/comment-and-title`;

    const payload = JSON.stringify({
      title,
      comment,
    });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await shrpaApi.put<CustomerGalleryPhotoGroupsFromServer>(uri, payload, config);

    return data;
  },

  async deleteMyUploadsGroupPhotos(customerId: string, photoIds: Array<string>): Promise<void> {
    const uri = `/photo-gallery/v2/${customerId}/my-uploads/photos`;

    const payload = JSON.stringify(photoIds);

    const config = { headers: { "Content-Type": "application/json" } };

    await shrpaApi.delete<any>(uri, { data: payload, ...config });
  },

  async movePhotosToAGallery(customerId: string, photoIds: Array<string>, galleryIdToMoveTo: string): Promise<void> {
    const uri = `/photo-gallery/v2/${customerId}/my-uploads/photos/move`;

    const payload = JSON.stringify({
      photoIds,
      galleryIdToMoveTo,
      clientSideDateTime: moment().format(),
    });

    const config = { headers: { "Content-Type": "application/json" } };

    await shrpaApi.put<Array<string>>(uri, payload, config);
  },

  async getAllCustomerManuallyUploadedMedia(customerId: string): Promise<Array<string>> {
    const { data } = await shrpaApi.get<Array<string>>(`/photo-gallery/v2/${customerId}/my-uploads/photos`);

    return data;
  },
};
